// extracted by mini-css-extract-plugin
export default {"banner":"EnvironmentBanner_banner__uSmDC","staging":"EnvironmentBanner_staging__9mbyq"};